import styled from 'styled-components';
import { Collapse, Card, Grid } from 'antd';
const isMobile = window.innerWidth < 768;

export const PageName = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 50px;
  padding: 5px 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;
`;

export const SearchIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: rgba(231, 250, 255, 1);
  
  svg {
    font-size: 24px;
    color: rgba(0, 141, 210, 1); 
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  width: ${isMobile ? '40%' : 'auto'};
  border: none;
  outline: none;
  padding: 10px;
  font-size: 18px;
  line-height: 24px;
  background-color: transparent;
`;

export const SearchButton = styled.button`
  background-color: #00bfff;
  color: white;
  border: none;
  padding: ${isMobile ? '0' : '10px 30px'};
  border-radius: ${isMobile ? '50%' : '40px'};
  font-size: ${isMobile ? '0' : '18px'};
  font-weight: 600;
  cursor: pointer;
  width: ${isMobile ? '50px' : 'auto'};
  height: ${isMobile ? '50px' : 'auto'};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #00a3e0;
  }
`;

export const ThemeMobileButton = styled.button`
  background-color: rgba(231, 250, 255, 1);
  color: rgba(0, 141, 210, 1);
  border: none;
  padding: 10px 20px;
  border-radius: 40px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  width: 108px;
  height: ${isMobile ? '50px' : 'auto'};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: rgba(244, 245, 247, 1);
  border-radius: 8px;
  padding: 8px;
`;

export const ToggleButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  margin-right: 8px;
  cursor: pointer;
  background-color: ${({ active }) => (active ? '#ffffff' : 'transparent')}; 
`;

export const ThemeCollapse = styled(Collapse)`
  margin-bottom: 16px;
  background-color: white;
  min-height: 56px;

  &.active {
    background-color: rgba(231, 250, 255, 1);
  }



  .ant-collapse-item.ant-collapse-item-active {
  background: rgba(231, 250, 255, 1);
  border-radius: 8px !important;
    .ant-typography.sc-braxZu.kVzYNl.css-dev-only-do-not-override-vr30i2 {
        color: rgba(0, 141, 210, 1) !important;
    }
  }

  .ant-collapse-item {
  background: #fff;
  border-radius: 8px !important;
  }

  .ant-collapse-header {
  flex-direction: row-reverse;
  }
  
  .ant-collapse-header-text{
  max-width: 190px;
  }
`;

export const ListIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 14px;
  height: 14px;

  .line {
    width: 100%;
    height: 4px;
    background-color: ${({ active }) => (active ? '#ffa500' : '#4a4a4a')};
    border-radius: 2px;
  }
`;

export const GridIcon = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 24px;
  height: 24px;
  justify-items: center;
  align-items: center;

  .grid-cell {
    width: 8px;
    height: 8px;
    background-color: ${({ active }) => (active ? '#ffa500' : '#4a4a4a')};
    border-radius: 2px;
  }
`;

export const ArticleCardContainer = styled.div`
  display: flex;
  flex-direction: ${({ viewMode }) => (viewMode === 'grid' ? 'row' : 'column')};
  gap: 24px;
  transition: all 0.3s ease;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ButtonContainer = styled.div`
  background-color: white;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid rgba(229, 233, 242, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(229, 233, 242, 0.1);
  }
`;

export const ThemeButton = styled.button<{ active: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid rgba(229, 233, 242, 1);
  background-color: ${({ active }) => (active ? 'rgba(0, 189, 244, 1)' : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#0A033C')};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: ${({ active }) => (active ? 'rgba(0, 189, 244, 1)' : 'rgba(229, 233, 242, 1)')};
  }

  svg {
    transform: ${({ active }) => (active ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 0.3s;
  }
`;

export const StyledCard = styled(Card)`

  .ant-card-body {
    padding: ${isMobile ? '12px' : '24px'} !important;
  }

`;